import React from 'react';

import { TextWithTooltip } from '../../../../../../../helpers/TextWithTooltip';
import { Translate } from '../../../../../../../helpers/Translate';

import { TooltipPlacement } from '../../../../../../../helpers/tooltips/tooltipsConstants';

import { ThreeDStockLifestylesListLightboxTitleLifestyle } from './ThreeDStockLifestylesListLightboxTitle.types';

interface ThreeDStockLifestylesListLightboxTitleProps {
  lifestyle: ThreeDStockLifestylesListLightboxTitleLifestyle;
}

function ThreeDStockLifestylesListLightboxTitle({
  lifestyle
}: ThreeDStockLifestylesListLightboxTitleProps) {
  return (
    <div className="flex-1 overflow-hidden p-1.5 text-left">
      <div className="text-sm">
        <div className="text-white truncate">
          {lifestyle.blocked ? (
            <span className="bg-red-200 text-gray-800 px-1 py-0.5 text-xs rounded uppercase mr-1">
              <Translate id="forms.fields.blocked" />
            </span>
          ) : null}
          <TextWithTooltip
            text={lifestyle.name}
            className="font-medium"
            tooltipPlacement={TooltipPlacement.BOTTOM}
          />
        </div>
        <div className="text-gray-300 truncate">
          {lifestyle.nda ? (
            <span className="bg-yellow-200 text-gray-800 px-1 py-0.5 text-xs rounded uppercase mr-1">
              <Translate id="forms.fields.nda" />
            </span>
          ) : null}
          {lifestyle.category ? (
            <TextWithTooltip
              text={lifestyle.category.localizedName}
              tooltipPlacement={TooltipPlacement.BOTTOM}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default ThreeDStockLifestylesListLightboxTitle;
